module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAqklEQVR4AWJwLwC0Xy4nCARBFLx69b55GIQmYTRmNCFMDObRAeg79EEY4aFS+BAbij1Wwe7O5/RVfidAs4khqp8bG7DKr+L2wOACjLwpPECzfyZvJhfg5SUOWEDLp5d7MDkSoNkZ+RFYByB584p8LOLmLXlDyz8PMPIzuhdoLk5OB5SX5wfwryD9I8z/DemI/KWYjsjfjrGI+CMZfyjNP5bzF5P8q9n/dnwHMjLb3LJ++zYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/return.png
// module id = +gYR
// module chunks = 212